import { THEME, HTML_HEADS } from '../../config';

function Head() {
  return HTML_HEADS[THEME];
}

export default Head;
